const fetchPaymentsGatewayName = async ({ accountID, shopID }) => {
  const res = await $.get(`/API/Account/${accountID}/Shop/${shopID}.json`);

  const { gatewayConfigID } = res.Shop;
  if (!gatewayConfigID) {
    return '';
  }

  const gwRes = await $.get(`/API/Account/${accountID}/GatewayConfig/${gatewayConfigID}.json`);
  const { gatewayID } = gwRes.GatewayConfig; // i.e.: "cayan" or "lightspeed-payments"
  return gatewayID;
};

const fetchHasEcom = async ({ accountID }) => {
  const res = await $.get(`/API/Account/${accountID}/Integration.json`);

  let integrations = res.Integration || [];
  if (!Array.isArray(integrations)) {
    integrations = [integrations];
  }

  const integration = integrations.find(
    ({ systemIntegrationID }) => systemIntegrationID === '50' || systemIntegrationID === '55'
  );
  return !!integration;
};

class Intercom {
  init() {
    // Do not load intercom if it is already loaded via the Chrome extension, or in Stencil
    if (window.Intercom || window.isGriffin()) {
      return;
    }

    // Set Intercom App ID based on environment
    const hostname = window.location.hostname;
    const isProd = /merchantos\.com/.test(hostname) || /lightspeedapp\.com/.test(hostname);
    const appID = isProd ? 'd758vmun' : 'x5qmpfth';

    // Intercom initialization script
    /* eslint-disable */
    // prettier-ignore
    (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + appID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
    /* eslint-enable */
    // Bootstrap Intercom
    window.merchantos.session.init().done(async () => {
      const session = window.merchantos.session.sessData;

      const { systemCustomerID: accountID, systemCustomerName: accountName, shopCount } = session;
      const { firstName, lastName, email, employeeID } = session.Employee;
      const { shopID, name: shopName } = session.Shop;

      const [hasEcom, gatewayName] = await Promise.all([
        fetchHasEcom({ accountID }),
        fetchPaymentsGatewayName({ accountID, shopID }),
      ]);

      // Determine placement and visuals of Intercom on page
      const intercomLauncher = {
        hide_default_launcher: true,
        vertical_padding: 20,
      };
      const getModule = moduleName => window.lsCloud.Modules.hasModule(moduleName);
      // User details to send to Intercom
      const intercomUser = {
        email,
        user_id: `${accountID}-${employeeID}`,
        employee_id: employeeID,
        name: `${firstName} ${lastName}`,
        shop_id: shopID,
        shop_name: shopName,
        owner: window.merchantos.session.hasRight('owner'),
        admin: window.merchantos.session.hasRight('admin'),
        module_analytics: getModule('reporting.analytics.autologin'),
        module_negative_inventory: getModule('inventory.negative_inventory'),
        module_advanced_reporting: getModule('advanced_reporting_cloud'),
        module_marketing_service: getModule('marketing.service'),
        module_settings_register_rules: getModule('settings.register_rules'),
        module_inventory_vendor_catalog_v2: getModule('inventory.vendor_catalog.v2'),
        has_ecom: hasEcom,
        has_integrated_payments: !!gatewayName,
        payments_gateway: gatewayName,
        accountStatus: window.merchantos.account.status,
        isGriffin: window.isGriffin(),
      };

      // Company information to send to Intercom
      const intercomCompany = {
        id: accountID,
        name: accountName,
        shop_count: shopCount,
      };

      // Intercom settings
      window.intercomSettings = {
        app_id: appID,
        ...intercomLauncher,
        ...intercomUser,
        company: {
          ...intercomCompany,
        },
      };

      // Bootstrap Intercom
      // Note: For SPA updates, see `router.js`
      window.Intercom('boot', window.intercomSettings);
      window.Intercom('update');
      window.Intercom('onShow', () => {
        // Hide the back button to prevent the user from accessing the conversation list for phase 1
        window.setTimeout(() => {
          const hideBackButtonStyles = $(
            '<style>.intercom-messenger-header-buttons-back-button { display: none; } .intercom-messenger-header { margin-left: -50px; }</style>'
          );
          $('html > head', $('.intercom-messenger-frame iframe').contents()).append(
            hideBackButtonStyles
          );
        }, 500);
      });

      // Intercom only allows 20 update call every 30 min
      // +2sec to ensure we call update right after the the limit refresh
      const safeUpdateRate = (1000 * 60 * 30) / 20 + 2000;
      setInterval(() => {
        window.Intercom('update');
      }, safeUpdateRate);
    });
  }
}

export default new Intercom();
